"use strict";

var _toConsumableArray = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plugins = void 0;
var plugins = [];
var interactorsInitializers = new Map();
var updatersInitializers = new Map();
var interactors = new Map();
var updaters = new Map();
var presets = new Map();
var drawers = new Map();
var pathGenerators = new Map();

var Plugins =
/*#__PURE__*/
function () {
  function Plugins() {
    _classCallCheck(this, Plugins);
  }

  _createClass(Plugins, null, [{
    key: "getPlugin",
    value: function getPlugin(plugin) {
      return plugins.find(function (t) {
        return t.id === plugin;
      });
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      if (!Plugins.getPlugin(plugin.id)) {
        plugins.push(plugin);
      }
    }
  }, {
    key: "getAvailablePlugins",
    value: function getAvailablePlugins(container) {
      var res = new Map();

      for (var _i = 0; _i < plugins.length; _i++) {
        var plugin = plugins[_i];

        if (!plugin.needsPlugin(container.actualOptions)) {
          continue;
        }

        res.set(plugin.id, plugin.getPlugin(container));
      }

      return res;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, sourceOptions) {
      for (var _i2 = 0; _i2 < plugins.length; _i2++) {
        var plugin = plugins[_i2];
        plugin.loadOptions(options, sourceOptions);
      }
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      return presets.get(preset);
    }
  }, {
    key: "addPreset",
    value: function addPreset(presetKey, options) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (override || !Plugins.getPreset(presetKey)) {
        presets.set(presetKey, options);
      }
    }
  }, {
    key: "addShapeDrawer",
    value: function addShapeDrawer(type, drawer) {
      if (!Plugins.getShapeDrawer(type)) {
        drawers.set(type, drawer);
      }
    }
  }, {
    key: "getShapeDrawer",
    value: function getShapeDrawer(type) {
      return drawers.get(type);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return drawers.keys();
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(type) {
      return pathGenerators.get(type);
    }
  }, {
    key: "addPathGenerator",
    value: function addPathGenerator(type, pathGenerator) {
      if (!Plugins.getPathGenerator(type)) {
        pathGenerators.set(type, pathGenerator);
      }
    }
  }, {
    key: "getInteractors",
    value: function getInteractors(container) {
      var res = interactors.get(container);

      if (!res) {
        res = _toConsumableArray(interactorsInitializers.values()).map(function (t) {
          return t(container);
        });
        interactors.set(container, res);
      }

      return res;
    }
  }, {
    key: "addInteractor",
    value: function addInteractor(name, initInteractor) {
      interactorsInitializers.set(name, initInteractor);
    }
  }, {
    key: "getUpdaters",
    value: function getUpdaters(container) {
      var res = updaters.get(container);

      if (!res) {
        res = _toConsumableArray(updatersInitializers.values()).map(function (t) {
          return t(container);
        });
        updaters.set(container, res);
      }

      return res;
    }
  }, {
    key: "addParticleUpdater",
    value: function addParticleUpdater(name, initUpdater) {
      updatersInitializers.set(name, initUpdater);
    }
  }]);

  return Plugins;
}();

exports.Plugins = Plugins;